import ElementUI from 'element-ui'
import axios from 'axios'
import printJs from 'print-js'
import _ from 'lodash'
import myaxios from '@/myaxios.js'
import componentDefinition from '@/components/componentDefinition'

function addRouter(menus, permission) { // 路由格式转换
    return menus.map((r, index) => {
        let loc = r.location.toUpperCase()
        if (!componentDefinition[loc]) {
            console.log(`${loc}:菜单的物理路径无效`)
        }
        return {
            path: r.url.split(`?`)[0],
            is_eject: r.is_eject,
            fullPath: r.url,
            name: r.index,
            meta: {
                requireAuth: true,
                title: r.name || `root`,
                permissions: permission,
                workbar: r.workbar
            },
            component: (componentDefinition[loc] && componentDefinition[loc].content), // || componentDefinition["UNFIND"]
            props: true,
            beforeEnter: (to, from, next) => {
                let pattern = new RegExp(`:[\\w\\d]+`, `g`)
                let flag = true
                to.matched.forEach(function(m) {
                    let obj = m.path.match(pattern)
                    // console.log(m.path)
                    if (obj != null && !_.isEmpty(to.params)) {
                        obj.forEach(function(o) {
                            if (!to.params[o.replace(`:`, ``)]) {
                                flag = false
                                return true
                            }
                        })
                    } else if (obj != null) {
                        flag = false
                    }
                })
                if (flag) { next() } else { next({ path: `/404` }) }
            }
        }
    })
}
function switchRouter(root, allrouters, permission) { // 路由格式转换
    return root.map((r, index) => {
        let children = _.filter(allrouters, { parent_id: r.id })
        let loc = r.location.toUpperCase()
        if (!componentDefinition[loc]) {
            console.log(`${loc}:菜单的物理路径无效`)
        }
        return {
            path: r.url.split(`?`)[0],
            is_eject: r.is_eject,
            fullPath: r.url,
            name: r.index,
            meta: {
                requireAuth: true,
                title: r.name || `root`,
                permissions: permission,
                workbar: r.workbar
            },
            component: (componentDefinition[loc] && componentDefinition[loc].content), // || componentDefinition["UNFIND"]
            props: true,
            beforeEnter: (to, from, next) => {
                let pattern = new RegExp(`:[\\w\\d]+`, `g`)
                let flag = true
                to.matched.forEach(function(m) {
                    let obj = m.path.match(pattern)
                    // console.log(m.path)
                    if (obj != null && !_.isEmpty(to.params)) {
                        obj.forEach(function(o) {
                            if (!to.params[o.replace(`:`, ``)]) {
                                flag = false
                                return true
                            }
                        })
                    } else if (obj != null) {
                        flag = false
                    }
                })
                if (flag) { next() } else { next({ path: `/404` }) }
            },
            children: children.length > 0 ? switchRouter(children, allrouters, permission) : []
        }
    })
}

const actions = {
    ADD_CURRENTUSER: ({ commit, getters }) => { //  获取当前用户信息
        return new Promise((resolve, reject) => {
            myaxios.get(`/api/AcisSystem/SysUser/GetCurrentUser`)
                .then((user) => {
                    commit(`setCurrentUser`, user)
                    resolve()
                }).catch(e => { console.log(e) })
        })
    },
    ADD_CURRENTWORKER: ({ commit, getters }) => { //  获取当前用户信息
        return new Promise((resolve, reject) => {
            myaxios.get(`/api/AcisSystem/Worker/GetCurrentWorker`)
                .then((worker) => {
                    commit(`setCurrentWorker`, worker)
                    resolve()
                }).catch(e => { console.log(e) })
        })
    },
    ADD_USERCONFIG: ({ commit, getters }) => { //  获取当前用户信息
        return new Promise((resolve, reject) => {
            myaxios.get(`/api/AcisSystem/UserConfig/GetByUser`)
                .then((data) => {
                    commit(`SET_USERCONFIG`, data)
                    resolve()
                }).catch(e => { console.log(e) })
        })
    },
    Get_Menu: ({ state, commit, getters }) => {
        if (!state.get_menu_ing) {
            commit(`SET_get_menu_ing`, true)
            let req1 = myaxios.getNoloading(`/api/AcisSystem/Authorization/GetAllMenu`)// 获取所有菜单项目
            return new Promise((resolve, reject) => {
                axios.all(([req1])).then(axios.spread(function(menus) {
                    commit(`SET_get_menu_ing`, false)
                    resolve(menus)
                })).catch(e => {
                    commit(`SET_get_menu_ing`, false)
                    reject(e)
                })
            })
        }
    },
    ADD_OtherSettingColumn: ({ state, commit, getters }) => {
        return new Promise(resolve => {
            let req = myaxios.getNoloading(`/api/AcisSystem/ApplySurgeryReadOnlyColumn/Get`)
            req.then(data => {
                commit(`SET_OtherSettingColumn`, data || [])
                resolve()
            }).catch(e => {
                console.log(e)
            })
        })
    },
    ADD_ExtendColumnList: ({ state, commit, getters }) => {
        return new Promise(resolve => {
            let req = myaxios.getNoloading(`/api/AcisSystem/SurgeryInfoExtraParam/Get`)
            req.then(data => {
                commit(`SET_ExtendColumnList`, data || [])
                resolve()
            }).catch(e => {
                console.log(e)
            })
        })
    },
    ADD_WORKBAR: ({ state, commit, getters }) => {
        if (!state.add_work_bar_ing) {
            commit(`SET_ADD_WORK_BAR_ING`, true)
            let req1 = myaxios.getNoloading(`/api/AcisSystem/Menu/Get`)// 获取所有菜单项目
            let req2 = myaxios.getNoloading(`/api/AcisSystem/Authorization/GetWorkBars`)// 获取当前用户工作栏
            let req3 = myaxios.getNoloading(`/api/AcisSystem/Authorization/GetPermissions`)// 获取当前用户的权限
            let req4 = myaxios.getNoloading(`/api/AcisSystem/UserConfig/GetByUser`)// 获取当前用户的权限
            return new Promise((resolve, reject) => {
                axios.all(([req1, req2, req3, req4])).then(axios.spread(function(menus, workbars, permission, userConfigs) {
                    workbars = _.filter(workbars, { is_deleted: false })
                    let routers = []
                    let business = []
                    for (let i = 0; i < workbars.length; i++) {
                        if (!workbars[i].menus) { continue }
                        let ms = workbars[i].menus.map((m, index) => {
                            // let m = _.find(menus,{id:mid})
                            m = Object.assign({}, m, { workbar: workbars[i].id, index: `${m.location}_${m.id}` })
                            // 菜单可以属于多个工作栏，避免路径跳转混乱，此处对路由进行混淆
                            if (_.startsWith(m.url, `/`)) {
                                m.url = `/${m.workbar}${m.url}` // 对路径添加 workbar混淆
                            } else {
                                m.url = `/${m.workbar}/${m.url}` // 对路径添加 workbar混淆
                            }
                            return m
                        })
                        ms = _.filter(_.orderBy(ms, `display_order`), { is_deleted: false })
                        let allid = _.map(ms, ar => ar.id)
                        let root = _.filter(ms, function(r) {
                            return _.indexOf(allid, r.parent_id) == -1
                        })
                        let partRouter = switchRouter(root, ms, permission.map(p => p.permission))
                        routers = routers.concat(partRouter)
                        workbars[i].menu_models = ms
                        workbars[i].first_model = partRouter[0]
                        workbars[i].menus = [] // 不需要再显示，减少内存消耗
                        let b = _.filter(ms, d => {
                            return d.business_level != `M000` && _.findIndex(getters.enum_business, { value: d.business_level }) > -1
                        })
                        business.push(...b)
                        // enum_business
                    }
                    commit(`SET_MENU`, _.filter(menus, { is_deleted: false }))
                    commit(`SET_WORKBAR`, workbars) // 组合当前用户的工作栏和菜单
                    commit(`SET_PERMISSIONS`, permission)
                    commit(`SETROUTERS`, routers) // 根据菜单组织路由
                    commit(`SET_BUSINESS`, business) // 被标记的业务菜单
                    commit(`SET_ADD_WORK_BAR_ING`, false)
                    commit(`SET_USERCONFIG`, userConfigs) // 用户个性参数设置
                    resolve(routers)
                })).catch(e => {
                    commit(`SET_ADD_WORK_BAR_ING`, false)
                    reject(e)
                })
            })
        }
    },
    ADD_ROUNTER: ({ state, commit, getters }) => {
        let req1 = myaxios.getNoloading(`/api/AcisSystem/Menu/Get`)// 获取所有菜单项目
        let req3 = myaxios.getNoloading(`/api/AcisSystem/Authorization/GetPermissions`)// 获取当前用户的权限
        let req2 = myaxios.getNoloading(`/api/AcisSystem/UserConfig/GetByUser`)// 获取当前用户的权限
        return new Promise((resolve, reject) => {
            axios.all(([req1, req3, req2])).then(axios.spread(function(menus, permission, userConfigs) {
                let routers = []
                if (!menus) { resolve() }
                let ms = menus.map((m, index) => {
                    if (!_.startsWith(m.url, `/`)) {
                        m.url = `/${m.url}`
                    }
                    return m
                })

                ms = _.filter(_.orderBy(ms, `display_order`), { is_deleted: false })
                let partRouter = addRouter(ms, permission.map(p => p.permission))
                routers = routers.concat(partRouter)

                commit(`SET_PERMISSIONS`, permission)
                commit(`SETROUTERS`, routers) // 根据菜单组织路由
                commit(`SET_USERCONFIG`, userConfigs) // 用户个性参数设置
                resolve(routers)
            })).catch(e => {
                reject(e)
            })
        })
    },
    ADD_SECTION: ({ commit, getters }) => {
        return myaxios.getNoloading(`/api/AcisSystem/Section/Get`)
            // _.filter(response,{is_deleted:false})
            .then((response) => {
                let sections = _.map(response, (d) => {
                    let code2 = d.code
                    if (d.hospital_ward) {
                        code2 += `/` + d.hospital_ward.name
                    }
                    return {
                        label: d.name,
                        value: d.id,
                        code: code2,
                        jianpin: d.abbr,
                        disabled: d.is_deleted
                    }
                })
                return commit(`SET_SECTION`, sections)
            })
    },
    ADD_SECTION_AUTH: ({ state, commit, getters }) => {
        if (state.section_auth.length == 0) {
            return myaxios.getNoloading(`/api/AcisSystem/Section/Search`)
                .then((response) => {
                    return commit(`SET_SECTION_AUTH`, response)
                })
        }
    },
    ADD_Inpatient_Section_AUTH: ({ state, commit, getters }) => {
        if (state.inpatient_section_auth.length == 0) {
            return myaxios.getNoloading(`/api/AcisSystem/InpatientSection/Search`)
                .then((response) => {
                    return commit(`SET_Inpatient_Section_AUTH`, response)
                })
        }
    },
    ADD_HOSPITAL_WARD: ({ commit, getters }) => {
        return myaxios.getNoloading(`/api/AcisSystem/HospitalWard/Get`)
            .then((response) => {
                return commit(`SET_HOSPITAL_WARD`, _.filter(response, { is_deleted: false }))
            })
    },
    ADD_HOSPITAL_WARD_AUTH: ({ commit, getters }) => {
        return myaxios.getNoloading(`/api/AcisSystem/HospitalWard/Search`)
            .then((response) => {
                return commit(`SET_HOSPITAL_WARD_AUTH`, response)
            })
    },
    ADD_OPERATION_WARD: ({ commit, getters }) => {
        let req1 = myaxios.getNoloading(`/api/AcisSystem/OperatingWard/Get`)
        let req2 = myaxios.getNoloading(`/api/AcisSystem/OperatingRoom/Get`)
        axios.all(([req1, req2])).then(axios.spread(function(ward, room) {
            commit(`SET_OPERATION_ROOM`, _.filter(room, { is_deleted: false }))
            let opw = _.map(_.filter(ward, { is_deleted: false }), (d) => {
                d.operation_room = _.filter(room, { dic_operating_ward_id: d.id, is_deleted: false })
                return d
            })
            return commit(`SET_OPERATION_WARD`, opw)
        }))
    },
    ADD_OPERATION_WARD_AUTH: ({ commit, getters }) => {
        return new Promise(resolve => {
            let req1 = myaxios.getNoloading(`/api/AcisSystem/OperatingWard/Search`)
            let req2 = myaxios.getNoloading(`/api/AcisSystem/OperatingRoom/Search`)
            axios.all(([req1, req2])).then(axios.spread(function(ward, room) {
                commit(`SET_OPERATION_ROOM_AUTH`, room)
                let opw = _.map(ward || [], (d) => {
                    d.operation_room = _.filter(room, { code: `${d.value}` })
                    return d
                })
                commit(`SET_OPERATION_WARD_AUTH`, opw)
                commit(`SET_OPERATION_WARD_AUTH_DISABLED`, opw)
                resolve(opw)
            }))
        })
    },
    ADD_RECOVERY_WARD: ({ commit, getters }) => {
        let req1 = myaxios.getNoloading(`/api/AcisSystem/RecoveryWard/Get`)
        let req2 = myaxios.getNoloading(`/api/AcisSystem/RecoveryBed/Get`)
        axios.all(([req1, req2])).then(axios.spread(function(ward, bed) {
            commit(`SET_RECOVERY_BED`, _.filter(bed, { is_deleted: false }))
            let rcw = _.map(_.filter(ward || [], { is_deleted: false }), (d) => {
                d.recovery_bed = _.filter(bed, { dic_recovery_ward_id: d.id, is_deleted: false })
                return d
            })
            return commit(`SET_RECOVERY_WARD`, rcw)
        }))
    },
    ADD_RECOVERY_WARD_AUTH: ({ commit, getters }) => {
        let req1 = myaxios.getNoloading(`/api/AcisSystem/RecoveryWard/Search`)
        let req2 = myaxios.getNoloading(`/api/AcisSystem/RecoveryBed/Search`)
        let req3 = myaxios.getNoloading(`/api/AcisSystem/HospitalWard/Search`)
        axios.all(([req1, req2, req3])).then(axios.spread(function(ward, bed, hsp) {
            commit(`SET_RECOVERY_BED_AUTH`, bed)
            let rcw = _.map(ward || [], (d) => {
                let hspWard = _.find(hsp, { value: parseInt(d.code) })
                d.hospital_ward = hspWard && hspWard.label
                d.recovery_bed = _.filter(bed, { code: `${d.value}` })
                return d
            })
            return commit(`SET_RECOVERY_WARD_AUTH`, rcw)
        }))
    },
    ADD_WARD_AUTH: ({ commit }) => {
        let req1 = myaxios.getNoloading(`/api/AcisSystem/HospitalWard/Search`)
        let req2 = myaxios.getNoloading(`/api/AcisSystem/OperatingWard/Search`)
        let req3 = myaxios.getNoloading(`/api/AcisSystem/OperatingRoom/Search`)
        let req4 = myaxios.getNoloading(`/api/AcisSystem/RecoveryWard/Search`)
        let req5 = myaxios.getNoloading(`/api/AcisSystem/RecoveryBed/Search`)
        myaxios.all(req1, req2, req3, req4, req5).then(([hsp, oward, room, rward, bed]) => {
            commit(`SET_HOSPITAL_WARD_AUTH`, hsp)
            commit(`SET_OPERATION_ROOM_AUTH`, room)
            let opw = _.map(oward || [], (d) => {
                d.operation_room = _.filter(room, { code: `${d.value}` })
                return d
            })
            commit(`SET_OPERATION_WARD_AUTH`, opw)
            commit(`SET_RECOVERY_BED_AUTH`, bed)
            let rcw = _.map(rward || [], (d) => {
                d.recovery_bed = _.filter(bed, { code: `${d.value}` })
                return d
            })
            commit(`SET_RECOVERY_WARD_AUTH`, rcw)
            let hw = _.groupBy(hsp, h => { return `${h.value}` })
            let ow = opw && opw.map(d => {
                let r = { ...d }
                r.value = `ow_${d.value}`
                r.group = hw[d.code] && hw[d.code][0].label
                r.groupId = hw[d.code] && hw[d.code][0].value
                r.code = `手术区`
                r.origion = d.value
                return r
            }) || []
            let rw = rcw.map(d => {
                let r = { ...d }
                r.value = `rw_${d.value}`
                r.group = hw[d.code] && hw[d.code][0].label
                r.groupId = hw[d.code] && hw[d.code][0].value
                r.code = `复苏室`
                r.origion = d.value
                return r
            }) || []
            commit(`SET_WARD_AUTH`, ow.concat(rw))
        })
    },
    ADD_SYS_CONFIG: ({ commit, getters, dispatch }) => {
        return new Promise((resolve, reject) => {
            dispatch(`ADD_SYS_DOCUMENT_LIST`).then(data => {
                let req = myaxios.getNoloading(`/api/AcisSystem/Config/Get`)
                req.then(config => {
                    let data = _.reduce(getters.sys_document_list, function(result, d, index) {
                        let c = _.find(getters.sys_document_list, { code: d.value })
                        result[d.value] = c && c.doc_id
                        return result
                    }, {})
                    let sysConfig = _.reduce(config, function(result, d, index) {
                        result[d.key] = d.value
                        return result
                    }, {})
                    resolve(Object.assign({ DOCUMENT: data }, sysConfig))
                }).catch(e => reject(e))
            })
        })
    },
    LOAD_PDF_DATA: ({ dispatch }, { host, params }) => { // 加载文书pdf
        const loading = ElementUI.Loading.service({
            lock: true,
            // text: 'loading',
            spinner: `el-icon-loading`,
            background: `rgba(0, 0, 0, 0)`
        })
        return new Promise((resolve, reject) => {
            axios.get(`${host}/doc3.ashx/fill`, {
                params: Object.assign({
                    from: `202005100000`,
                    to: `202005100000`,
                    id3: 1
                }, params)
            }).then((res) => {
                if (res.Status == `SUCCESS`) {
                    axios.get(res.TargetUrl + `&type=base64&r=` + Math.random()).then(data => {
                        loading.close()
                        resolve(data)
                    }).catch(e => reject(e))
                } else {
                    loading.close()
                    console.error(`load instance failed.${res.Content}`)
                    ElementUI.Message.warning(`文书打印异常，请重试`)
                    reject(res.Content)
                }
            }).catch(e => reject(e))
        })
    },
    PRINT_PDF: ({ dispatch }, { host, params }) => { // 加载文书pdf
        if (!params.docid) {
            ElementUI.Message.warning(`请配置相关文书`)
            return
        }
        dispatch(`LOAD_PDF_DATA`, { host, params }).then(data => {
            printJs({ printable: data,
                type: `pdf`,
                base64: true,
                onPrintDialogClose: () => {
                    if (params.isShowSendPrintMessage === `true`) {
                        setTimeout(function() {
                            ElementUI.MessageBox.confirm(`请确认打印是否已完成`, `提示`, {
                                confirmButtonText: `打印完成`,
                                cancelButtonText: `打印未完成`
                            })
                        }, 2000)
                    }
                } })
        }).catch(e => {})
    },
    PRINT_PDF_LIST: ({ dispatch }, { host, params }) => { // 加载文书pdf
        if (!params.docs || params.docs.length == 0) {
            ElementUI.Message.warning(`请选择相关文书`)
            return
        }
        return new Promise((resolve, reject) => {
            const loading = ElementUI.Loading.service({
                lock: true,
                // text: 'loading',
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            dispatch(`LOAD_PDF_LIST_DATA`, { host, params }).then(urls => {
                console.log(`LOAD_PDF_LIST_DATA`)
                console.log(urls)
                loading.close()
                dispatch(`GET_PDFLIST_DATA`, { urls }).then(pdfdata => {
                    printJs({ printable: pdfdata,
                        type: `pdf`,
                        base64: true,
                        onPrintDialogClose: () => {
                            if (params.isShowSendPrintMessage === `true`) {
                                setTimeout(function() {
                                    ElementUI.MessageBox.confirm(`请确认打印是否已完成`, `提示`, {
                                        confirmButtonText: `打印完成`,
                                        cancelButtonText: `打印未完成`
                                    }).then(() => {
                                        resolve()
                                    }).catch(e => {
                                        reject(``)
                                    })
                                }, 2000)
                            } else {
                                resolve()
                            }
                        } })
                }).catch(e => {
                    loading.close()
                    reject(``)
                })
            }).catch(e => {
                loading.close()
                reject(``)
            })
        })
    },
    GET_PDFLIST_DATA: ({ dispatch }, { urls }) => { // 加载文书pdf
        return new Promise((resolve, reject) => {
            let req = myaxios.post(`/api/Operation/Home/printPdfList`, urls)
            req.then(result => {
                resolve(result)
            }).catch(e => reject(e))
        })
    },
    // LOAD_PDF_LIST_DATA: ({ dispatch }, { host, params }) => { // 加载文书pdf
    //     return new Promise((resolve, reject) => {
    //         try {
    //             let promiseArray = params.docs && params.docs.map((item, index) => {
    //                 let itemparams = Object.assign(
    //                     {
    //                         docid: item.docid || item.docno,
    //                         id1: params.id1,
    //                         docbizid: item.docbizid,
    //                         from: params.from,
    //                         to: params.to,
    //                         username: params.username
    //                     }
    //                 )
    //                 return dispatch(`GET_PDF_URL`, { host, itemparams })
    //             })
    //             Promise.all(promiseArray).then((result) => {
    //                 resolve(result)
    //             })
    //         } catch (e) {
    //             ElementUI.Message.warning(`文书打印异常，请重试`)
    //             reject(e)
    //         }
    //     })
    // },
    LOAD_PDF_LIST_DATA: ({ dispatch }, { host, params }) => { // 加载文书pdf
        return new Promise(async(resolve, reject) => {
            try {
                const urls = []
                let promiseArray = params.docs && params.docs.map((item, index) => {
                    let itemparams = Object.assign(
                        {
                            docid: item.docid || item.docno,
                            id1: params.id1,
                            docbizid: item.docbizid,
                            from: params.from,
                            to: params.to,
                            username: params.username
                        }
                    )
                    return dispatch(`GET_PDF_URL`, { host, itemparams })
                })
                // 文书那边不可多份文书同时调用一个签名图片，所以需要改成循环
                for (const promise of promiseArray) {
                    const url = await promise
                    urls.push(url)
                }
                resolve(urls)
                // Promise.all(promiseArray).then((result) => {
                //     resolve(result)
                // })
            } catch (e) {
                ElementUI.Message.warning(`文书打印异常，请重试`)
                reject(e)
            }
        })
    },
    GET_PDF_URL: ({ dispatch }, { host, itemparams }) => { // 加载文书pdf
        return new Promise((resolve, reject) => {
            axios.get(`${host}/doc3.ashx/fill`, {
                params: Object.assign({
                    from: `202005100000`,
                    to: `202005100000`,
                    id3: 1
                }, itemparams)
            }).then((res) => {
                if (res.Status == `SUCCESS`) {
                    resolve(res.TargetUrl)
                } else {
                    reject(res.Content)
                }
            }).catch(e => reject(e))
        })
    },
    LOAD_PDF_DATA_MehealthAgreement: ({ dispatch }, { host, params }) => { // 加载文书pdf
        const loading = ElementUI.Loading.service({
            lock: true,
            // text: 'loading',
            spinner: `el-icon-loading`,
            background: `rgba(0, 0, 0, 0)`
        })
        return new Promise((resolve, reject) => {
            axios.get(`${host}/doc3.ashx/fill`, {
                params: Object.assign({
                    from: `202005100000`,
                    to: `202005100000`,
                    id3: 1
                }, params)
            }).then((res) => {
                if (res.Status == `SUCCESS`) {
                    loading.close()
                    resolve(res.TargetUrl)
                    // axios.get(res.TargetUrl + `&type=base64&r=` + Math.random()).then(data => {

                    // }).catch(e => reject(e))
                } else {
                    loading.close()
                    console.error(`load instance failed.${res.Content}`)
                    ElementUI.Notification.error({
                        title: `文书加载错误`,
                        message: res.Content
                    })
                    reject(res.Content)
                }
            }).catch(e => reject(e))
        })
    },
    PRINT_PDF_MehealthAgreement: ({ dispatch }, { host, params }) => { // 加载文书pdf
        if (!params.docid) {
            ElementUI.Message.warning(`请配置相关文书`)
            return
        }
        dispatch(`LOAD_PDF_DATA_MehealthAgreement`, { host, params }).then(data => {
            console.log(`meehealth://${data}|${params.default_printer_name}`)
            if (params.default_printer_name != ``) {
                window.location = `meehealth://${data}|${params.default_printer_name}`
            } else {
                window.location = `meehealth://${data}`
            }

            if (params.isShowSendPrintMessage === `true`) {
                setTimeout(function() {
                    ElementUI.MessageBox.confirm(`请确认打印是否已完成`, `提示`, {
                        confirmButtonText: `打印完成`,
                        cancelButtonText: `打印未完成`
                    })
                }, 2000)
            }
        }).catch(e => {
            ElementUI.Notification.error({
                title: `文书加载错误`,
                message: e
            })
        })
    },
    ADD_SYS_DOCUMENT_LIST: ({ state, commit, getters }) => {
        if (state.sys_document_list.length == 0) {
            return new Promise((resolve, reject) => {
                myaxios.getNoloading(`/api/AcisSystem/DocConfig/Get`)
                    .then((response) => {
                        let opw = _.map(_.orderBy(response, `display_order`) || [], (d) => {
                            d = { value: d.code, label: d.name, code: d.code, doc_type: d.doc_type, is_enable: d.is_enable, doc_id: d.doc_id, score_many_times: d.score_many_times }
                            return d
                        })
                        commit(`SET_SYS_DOCUMENT_LIST`, opw)
                        resolve(opw)
                    }).catch(e => { console.log(e) })
            })
        }
    },
    WZT_PDF_SendSign: ({ dispatch }, { host, params }) => { // 加载文书pdf
        return new Promise((resolve, reject) => {
            console.log(`WztPdfUploadInstance`)
            console.log(params)
            axios.post(`${host}/Wth/WztPdfUploadInstance?docbizid=${params.docbizid}&operator=${params.operator}`).then((res) => {
                console.log(res)
                if (res && res.Status && res.Status == `SUCCESS`) {
                    dispatch(`WZT_CaUploadPdf`, { host, params }).then(data => {
                        if (data && data.Status && data.Status == `SUCCESS`) {
                            resolve(data.Content)
                        } else {
                            reject(data.Content)
                        }
                    }).catch(e => {
                        reject(e)
                    })
                } else {
                    reject(`文书pdf生成失败`)
                }
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },
    WZT_CaUploadPdf: ({ dispatch }, { host, params }) => { // 加载文书pdf
        return new Promise((resolve, reject) => {
            console.log(`CaUploadPdf`)
            console.log(params)
            axios.post(`${host}/Wth/CaUploadPdf?docbizid=${params.docbizid}`).then((res) => {
                console.log(res)
                resolve(res)
            }).catch(e => reject(e))
        })
    },
    WZT_CaRevokePdf: ({ dispatch }, { host, params }) => { // 加载文书pdf
        return new Promise((resolve, reject) => {
            console.log(`CaRevokePdf`)
            console.log(params)
            axios.post(`${host}/Wth/CaRevokePdf?docbizid=${params.docbizid}`).then((res) => {
                console.log(res)
                if (res.Status == `SUCCESS`) {
                    resolve(res.Content)
                } else {
                    reject(res.Content)
                }
            }).catch(e => reject(e))
        })
    },
    // 获取多语言翻译信息到Store里缓存
    ADD_LANGUAGES: ({ commit, getters }) => {
        return new Promise((resolve, reject) => {
            myaxios.getNoloading(`/api/AcisSystem/Language/Get`)
                .then((languages) => {
                    commit(`SET_LANGUAGES`, languages)
                    resolve(languages)
                }).catch(e => { console.log(e) })
        })
    }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js